import { Badge } from "@/components/ui/badge";

interface ConfidenceBadgeProps {
  confidence: number;
}

/**
 * Shared match-confidence badge across every "match to transaction" modal (payables,
 * receivables, receipts): >=80 reads as a strong match, >=50 a plausible one, anything lower a
 * weak suggestion the consultant should look at closely.
 */
export default function ConfidenceBadge({ confidence }: ConfidenceBadgeProps) {
  if (confidence >= 80) return <Badge variant="paid">{confidence}%</Badge>;
  if (confidence >= 50) return <Badge variant="pending">{confidence}%</Badge>;
  return <Badge variant="secondary">{confidence}%</Badge>;
}
